import { status_colors } from "./_constants"
import { Ride } from "./_models";

export const getStatusColor = (ride: Ride): string => {
    for (const key in status_colors) {
        if (key === ride.status) {
            return status_colors[key];
        }
    }
    return "transparent";
}
